import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "coreOS",
  "use": "coreOS-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"coreOS\"><path d=\"M9 2C5.13 2 2 5.13 2 9s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7m-2.1 9.1c0-4.9.7-7 2.1-8.4A6.3 6.3 0 0 1 15.3 9c-1.4 1.4-3.5 2.1-8.4 2.1m1.96-5.42c-.28.92-.48 2.18-.54 4 1.82-.06 3.08-.25 4-.54a4.88 4.88 0 0 0-3.46-3.46\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol